import React from 'react';
import { AuthProvider as OidcProvider } from 'react-oidc-context';
import { getUserManager } from '../utils/userManager';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  // Use the shared UserManager instance
  const userManager = getUserManager();

  return <OidcProvider userManager={userManager}>{children}</OidcProvider>;
}
